import React, { useMemo, useState } from 'react';
import { KeyMetricGraphBox } from 'src/components/organisms/KeyMetricGraphBox';
import { useMMDataContext } from 'src/features/MM/contexts/MMDataContext';
import { useChartEffectTickFormatter } from 'src/hooks/useEffectFormatter';
import { incrementalMetricDef } from 'src/utils/metricDefinitions';
import { useAggregationLevelContext } from '../../contexts/AggregationLevelContext';
import { useGetDateAxisFormatter } from '../../hooks/useGetDateAxisFormatter';
import { getAggregateLevelData } from '../../utils/getAggregateLevelData';
import { TimeseriesDataTableModal } from '../molecules/TimeseriesDataTableModal';
import { useKpiMetricLabels } from 'src/hooks/useKpiMetricLabels';

export const IncrementalSalesBox: React.FC = () => {
  const { decomps } = useMMDataContext();
  const { metricLabel, incrementalLabel } = useKpiMetricLabels();
  const { aggregateLevel } = useAggregationLevelContext();

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const yAxisFormatter = useChartEffectTickFormatter();

  const chartData = useMemo(() => {
    return getAggregateLevelData(decomps, aggregateLevel);
  }, [decomps, aggregateLevel]);

  const xAxisFormatter = useGetDateAxisFormatter();

  return (
    <KeyMetricGraphBox
      title={incrementalLabel}
      // Metric-aware label — KPI metrics are dynamic per model
      legendLabel={incrementalLabel}
      data={chartData}
      xAxisFormatter={xAxisFormatter}
      yAxisFormatter={yAxisFormatter}
      isError={decomps.isError}
      isLoading={decomps.isLoading}
      infoText={incrementalMetricDef(metricLabel)}
      exportEnabled
      onTableModalOpen={setModalIsOpen}
      tableModal={
        <TimeseriesDataTableModal
          isOpen={modalIsOpen}
          setIsOpen={setModalIsOpen}
          yFormatter={yAxisFormatter}
          data={chartData}
          headerName={incrementalLabel}
        />
      }
    />
  );
};
